<template>
   <Modal
      v-model="model"
      size="lg"
      :title="$t('web.components.sidebar.impersonate-title')"
      :description="$t('web.components.sidebar.impersonate-description')"
   >
      <template #header>
         <TextInput
            v-model="organizationQuery"
            grow
            :label="$t('form.organization-search')"
            :placeholder="$t('form.organization-search-placeholder')"
         />
      </template>
      <div class="flex flex-col gap-4">
         <template v-for="group in groupedOrganizations" :key="group.group_id">
            <div v-if="group.organizations.length > 0" class="flex flex-col gap-2">
               <p class="h-s px-1">
                  {{ group.group_name }}
               </p>
               <ul class="flex flex-col gap-2">
                  <li v-for="item in group.organizations" :key="item.organization_id">
                     <OrganizationItem
                        :name="item.organization_name"
                        :image="getFileUrlFromBucket(item.propic_url)"
                        :to="$localePath(`/dashboard/${item.organization_id}`)"
                     />
                  </li>
               </ul>
            </div>
         </template>
      </div>
   </Modal>
</template>

<script lang="ts" setup>
import { getFileUrlFromBucket } from '~/composables/api/helpers/get-file-url'
import { useAccessibleOrganizations } from '~/composables/api/queries/accessible-organizations'

const organizationQuery = ref<string>()

const accessibleOrganizations = useAccessibleOrganizations(
   computed(() => ({
      enabled: true,
   }))
)

const groupedOrganizations = computed(() => {
   const data = accessibleOrganizations.data.value || []
   const filtered = data.filter((o) =>
      organizationQuery.value
         ? o.organization_name?.toLowerCase().includes(organizationQuery.value.toLowerCase())
         : true
   )

   const groups = new Map<
      string,
      { group_id: string; group_name: string; organizations: typeof filtered }
   >()

   for (const org of filtered) {
      const key = org.group_id
      if (!groups.has(key)) {
         groups.set(key, {
            group_id: org.group_id,
            group_name: org.group_name,
            organizations: [],
         })
      }
      groups.get(key)!.organizations.push(org)
   }

   return Array.from(groups.values())
})

const model = defineModel<boolean>()
</script>
